import React, { useRef } from "react";

import { useSelector } from "react-redux";

import "./Poster.css";
import ProgressiveImage from "./ProgressiveImage";

const Poster = () => {

    const isMobile = useSelector(state => state.device.isMobile);
    const textSectionRef = useRef(null);

    function mobilizeClass(baseClass) {
        let mobilizeClass = baseClass;
        if (isMobile) {
            mobilizeClass += " " + baseClass + "-mobile";
        }
        return mobilizeClass;
    }

    const handleImageClick = () => {
        if (isMobile && textSectionRef.current) {
            textSectionRef.current.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };


    return (
        <article className="poster" itemScope itemType="https://schema.org/Event">
            {isMobile ? (
                // Mobile layout: Image first, then text below
                <>
                    <div className="poster-image" onClick={handleImageClick}>
                        <ProgressiveImage 
                            loResSrc="media/GrayscaleTempleLoRes.webp" 
                            hiResSrc="media/GrayscaleTemple1080.webp" 
                            alt="Tantalus improv comedy performance poster" 
                        />
                    </div>
                    <div className="poster-text-container" ref={textSectionRef}>
                        <div className="poster-text">
                            <h1 itemProp="name">Improv on The Hudson</h1>
                            <h2 itemProp="startDate" content="2024-12-06T20:00:00-05:00">Saturday, March 7th</h2>
                            <div id={mobilizeClass("poster-times")}>
                                <div>
                                <h3>Doors: 7:30</h3>
                                </div>
                                <div>
                                <h3>Curtain: 8:00</h3>
                                </div>
                                <div>
                                <h3>Done: 9:30</h3>
                                </div>
                            </div>
                            <div id="poster-address" itemProp="location" itemScope itemType="https://schema.org/Place">
                                <h4 itemProp="name">The Lobby at The Ritz</h4>
                                <h4 itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                                    <span itemProp="streetAddress">107 Broadway</span>
                                </h4>
                                <h4 itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                                    <span itemProp="addressLocality">Newburgh</span>, <span itemProp="addressRegion">NY</span>
                                </h4>
                            </div>
                            <div style={{display: 'none'}} itemProp="description">
                                Tantalus improv comedy performance at St. Rita's Music Room in Beacon, NY
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                // Desktop layout: Original structure
                <div className="poster-text-container">
                    <div className="poster-text-spacer" />
                    <div className="poster-text">
                        <h1 itemProp="name">Improv on The Hudson</h1>
                        <div className="poster-image">
                            <ProgressiveImage 
                                loResSrc="media/GrayscaleTempleLoRes.webp" 
                                hiResSrc="media/GrayscaleTemple1080.webp" 
                                alt="Improv on The Hudson improv comedy performance poster" 
                            />
                        </div>
                        <h2 itemProp="startDate" content="2024-12-06T20:00:00-05:00">Saturday, March 7th</h2>
                        <div id={mobilizeClass("poster-times")}>
                            <div>
                            <h3>Doors: 7:30</h3>
                            </div>
                            <div>
                            <h3>Curtain: 8:00</h3>
                            </div>
                            <div>
                            <h3>Done: 9:30</h3>
                            </div>
                        </div>
                        <div id="poster-address" itemProp="location" itemScope itemType="https://schema.org/Place">
                            <h4 itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                                <span itemProp="streetAddress">107 Broadway</span>
                            </h4>
                            <h4 itemProp="name">The Lobby at The Ritz</h4>
                            <h4 itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                                <span itemProp="addressLocality">Newburgh</span>, <span itemProp="addressRegion">NY</span>
                            </h4>
                        </div>
                        <div style={{display: 'none'}} itemProp="description">
                            Tantalus improv comedy performance at St. Rita's Music Room in Beacon, NY
                        </div>
                    </div>
                    <div className="poster-text-spacer" />
                </div>
            )}
        </article>
    );
}

export default Poster;